import { configureStore } from '@reduxjs/toolkit';

import assetsReducer from './assets.js';
import currentTimeReducer, { initialise as initialiseCurrentTime } from './current-time.js';
import nftReducer from './nfts.js';
import portfolioReducer from './portfolio.js';
import userReducer from './user.js';
import userPreferencesReducer from './user-preferences.js';


// configure the redux store
var store = configureStore({
    reducer: {
      assets: assetsReducer,
      currentTime: currentTimeReducer,
      nfts: nftReducer,
      portfolio: portfolioReducer,
      user: userReducer,
      userPreferences: userPreferencesReducer
    },
});


// fire-off any logic that is needed to initialise the slices
initialiseCurrentTime(store.dispatch);


export default store;

